// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './i18n';
import './index.css';
import "react-toastify/dist/ReactToastify.css";
import { installTranslatorDomGuard } from './translatorDomGuard';

// Before the first render: a browser translator must not be able to white-page the app.
installTranslatorDomGuard();

// Global axios interceptor to add view_mode parameter when admin views as user
axios.interceptors.request.use(
  (config) => {
    const viewMode = localStorage.getItem('viewMode');
    if (viewMode === 'user') {
      // Add view_mode to query params for all requests
      config.params = config.params || {};
      config.params.view_mode = 'user';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* UserProvider lives inside App (App.js); a second one here was redundant
        and double-fired the boot auth refresh, so it was removed. */}
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
